import { render, staticRenderFns } from "./TenderBreakdownHeader.vue?vue&type=template&id=96de74dc&"
import script from "./TenderBreakdownHeader.vue?vue&type=script&lang=js&"
export * from "./TenderBreakdownHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports